var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown-component",class:{ disabled: _vm.second > 0 },on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.second <= 0 ? _vm.codeMsg : '剩余' + _vm.second + 's')+" ")]},{"second":_vm.second})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }